import { usePageMeta } from "@/hooks/usePageMeta";

const quotes = [
  {
    id: "01",
    placement: "Featured · Homepage hero",
    quote:
      "Shivani understood the brand instantly. She came in with a clear point of view and delivered visuals that looked like they were shot for Kore specifically — not pulled from a generic template. It was from a brand marketer's lens that's rare to come by.",
    name: "Bani Singh",
    role: "Founder, Kore",
    company: "Forbes 30u30 Asia",
  },
  {
    id: "02",
    placement: "Services & Work",
    quote:
      "Shivani transformed our product photos into high-quality campaign imagery that captured our brand's specific aesthetic — delivered within a very impressive timeframe. If you're looking for someone who understands how to apply AI to real-world marketing needs, I highly recommend her work.",
    name: "Diya Roongta",
    role: "Rotational PM, Meta",
    company: "Columbia M.S. CS · Bain",
  },
  {
    id: "03",
    placement: "About",
    quote:
      "From day one, Shivani picked up the ropes with incredible speed — managing multiple client projects, developing clear brand strategies, and turning complex reports into marketable content. Her dedication, quick learning, and ability to thrive under pressure make her a standout professional.",
    name: "Kriti Mukherjee",
    role: "Fractional CMO · CEO, LUME",
    company: "Independent Director, IICA",
  },
];

export default function Testimonials() {
  usePageMeta({
    title: "Testimonials — Shivani | What Clients Say",
    description: "What founders, product managers, and brand builders say about working with Shivani.",
    ogTitle: "Testimonials — Shivani | What Clients Say",
    ogDescription: "Real words from founders and brand builders who've worked with Shivani.",
  });
  return (
    <div data-testid="testimonials-page">
      {/* INTRO */}
      <section className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 pt-16 md:pt-24 pb-12">
        <p className="eyebrow mb-8">Testimonials · In other people&apos;s words</p>
        <h1
          className="serif-display leading-[0.92] max-w-[18ch]"
          style={{ fontSize: "clamp(2.85rem, 7vw, 6.25rem)" }}
        >
          What founders <span className="serif-italic">say back.</span>
        </h1>
        <div className="grid md:grid-cols-12 mt-10">
          <p className="md:col-span-6 md:col-start-6 text-base md:text-lg leading-relaxed">
            A short, edited collection — founders, brand leads, and former managers. Three voices,
            each speaking to a different side of the work.
          </p>
        </div>
      </section>

      {/* QUOTES */}
      <section className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 pb-24 md:pb-32">
        {quotes.map((q) => (
          <article
            key={q.id}
            data-testid={`testimonial-${q.id}`}
            className="grid md:grid-cols-12 gap-6 md:gap-12 py-20 md:py-28"
            style={{ borderTop: "0.5px solid rgba(26,26,26,0.35)" }}
          >
            <div className="md:col-span-3">
              <p
                className="text-[11px] font-sans font-medium uppercase tracking-[0.22em]"
                style={{ color: "rgba(26,26,26,0.55)" }}
              >
                {q.id} · {q.placement}
              </p>
            </div>
            <div className="md:col-span-9">
              <blockquote
                className="serif-italic font-serif leading-[1.12] pl-6 md:pl-10"
                style={{
                  borderLeft: "0.5px solid #1A1A1A",
                  fontSize: "clamp(1.65rem, 3.6vw, 3rem)",
                }}
              >
                {q.quote}
              </blockquote>
              <footer className="mt-10 pl-6 md:pl-10">
                <p className="serif-display text-2xl md:text-3xl leading-tight">
                  — {q.name}
                </p>
                <p
                  className="mt-2 text-[0.95rem]"
                  style={{ color: "rgba(26,26,26,0.7)" }}
                >
                  {q.role}
                </p>
                <p
                  className="text-[0.85rem]"
                  style={{ color: "rgba(26,26,26,0.55)" }}
                >
                  {q.company}
                </p>
              </footer>
            </div>
          </article>
        ))}
        <div className="rule" />
      </section>
    </div>
  );
}
